import { motion } from 'framer-motion';

/**
 * Button Component
 * Props:
 * - text
 * - type ('primary'|'secondary')
 * - onClick
 * - disabled
 * Features:
 * - Tailwind styles: primary bg-yellow-500 text-white, secondary bg-gray-100 text-gray-800
 * - Animations: scale-up hover, focus ring
 * - Loose coupling: click handled via prop
 */

const Button = ({
  text,
  type = 'primary',
  onClick,
  disabled = false,
  className = '',
  icon = null,
}) => {
  const baseClasses = 'px-6 py-3 rounded-lg font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center space-x-2';
  
  const typeClasses = {
    primary: 'bg-secondary-400 text-white hover:bg-secondary-500 focus:ring-secondary-400',
    secondary: 'bg-gray-100 text-gray-800 hover:bg-gray-200 focus:ring-gray-300',
  };

  return (
    <motion.button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${typeClasses[type]} ${className}`}
      whileHover={!disabled ? { scale: 1.05 } : {}}
      whileTap={!disabled ? { scale: 0.95 } : {}}
      transition={{ duration: 0.2 }}
    >
      {icon && <span>{icon}</span>}
      <span>{text}</span>
    </motion.button>
  );
};

export default Button;

